const { identicons, avatar } = require("./avatar");

function create(path, address, xsa) {
  const svg = identicons[xsa % identicons.length](path, address);
  const label = `<br> <div class='address'>${
    xsa % identicons.length
  } - ${address}</div>`;
  const div = document.createElement("div");
  div.innerHTML = svg.trim();
  div.setAttribute("data-addr", address);
  return div;
}

function avatarFor(address) {
  const [path, xsa] = avatar(address);
  const elt = create(path, address, xsa);
  document.getElementById("output").innerHTML = elt.innerHTML;
}

const input = document.getElementById("tzaddress");

function download() {
  const address = input.value.trim() || window.address;
  console.log({ address });
  avatarFor(address);
  const svgElement = document.querySelector("svg");

  const imgSource =
    "data:image/svg+xml;base64," + window.btoa(svgElement.outerHTML);

  var dl = document.createElement("a");
  document.body.appendChild(dl);
  dl.setAttribute("href", imgSource);
  dl.setAttribute("download", `identicon-${address}.svg`);
  dl.click();
}

input.addEventListener("change", (evt) => {
  if (evt.target.value) {
    try {
      const address = evt.target.value.trim();
      if (
        /^tz[123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz]{34}$/.test(
          address
        )
      ) {
        avatarFor(address);
      } else {
        evt.setAttribute("placeholder", "invalid address!");
      }
    } catch (err) {}
  }
});

document.getElementById("generate").addEventListener("click", () => {
  avatarFor(input.value.trim());
});

document.getElementById("download").addEventListener("click", download);

window.address = "tz1LKpeN8ZSSFNyTWiBNaE4u4sjaq7J1Vz2z";
avatarFor(window.address);

const controls = document.getElementById("control");
document.body.onkeydown = (e) => {
  const key = e.key;
  if (key === "d") {
    download();
  } else if (
    !["Meta", "Control", "Alt", "Shift", "v", "Enter", "Tab"].includes(key) &&
    input !== document.activeElement
  ) {
    controls.classList.toggle("hidden");
  }
};
